import React from 'react'
import ActionButton from '../../../../library/input/buttons/button/SarasButton'
import * as fn from '../../../../helper/uiFunctions';

const DocLinkWithSHEditor =(props)=>{
    const {formObject, viewData, reloadSearch} = props;

    // console.log("DocLinkWithSHEditor viewData",viewData);
    
    const valCssClass = formObject.getValueFromKey(viewData, "dataList.valCssClass", "");

    //build the url for link
    const docModule = formObject.getValueFromKey(viewData, "dataList.module", formObject.docModule);
    const docView = formObject.getValueFromKey(viewData, "dataList.view", formObject.docView);
    const valLDT = formObject.getValueFromKey(viewData, "dataList.valLDT", 0);

    const url = fn.getShowDocumentLink(valLDT, viewData.val, "", 1, docModule, docView);

    const onPopupClose = () => {
        if(reloadSearch)reloadSearch();
    }

    const onButtonClick = (e) => {
        let customAction = {actionId:"edit", skipMasterKey: 1, containerKey: "popup"};
        
        //TODO give support for dashboard
        if (!customAction.actionParam) {
            customAction["actionParam"] = {};
        }

        customAction.onModalClose = onPopupClose;
        customAction.actionParam["showModeID"] = "sh";
        customAction.actionParam["dtId"] = viewData.dataList.valLDT;
        customAction.actionParam["dId"] = viewData.val;

        customAction["actionName"] = formObject.getValueFromKey(viewData, "dataList.actionName", "");

        if (customAction.actionId) formObject.onFormAction(customAction, "", "");
    }

    return (
        <div className="saras-cell">
            <div className={valCssClass}>
                <div className="uiLabelWithAction">
                    <span className="uiLWALabel" >
                        <a target={docModule === formObject.docModule 
                            && fn.compareNumber(formObject.dtId, valLDT) ? '' : '_blank' } 
                            className={`document-key uiLink ${valCssClass}`} href={url}>{viewData.valF}</a>
                    </span>
                    <span className="uiLWAAction">
                        <ActionButton onClick={onButtonClick} 
                            starIcon="edit"
                            onlyIcon={true}
                            tooltip="Edit"
                            starIconClassName="uiLink uiIcon"
                            className={''} />
                    </span>
                </div>
            </div>
        </div>
    )
}

export default DocLinkWithSHEditor